import React from 'react';

const PrintDecisionConseil = ({ tableauHonneur }) => {
  const decisions = [
    { value: 'FELICITATION', label: 'Félicitation' },
    { value: 'ENCOURAGEMENT', label: 'Encouragement' },
    { value: 'TABLEAU_D_HONNEUR', label: 'Tableau d\'Honneur' },
    { value: 'AVERTISSEMENT', label: 'Avertissement' },
    { value: 'BLAME', label: 'Blâme' }
  ];

  return (
    <div style={{ marginBottom: '8px', pageBreakInside: 'avoid' }}>
      <div style={{ 
        border: '1px solid #000', 
        padding: '6px',
        backgroundColor: '#f8f9fa',
        minHeight: '140px' // Même hauteur que PrintClassStatistics
      }}>
        <h4 style={{ 
          margin: '0 0 4px 0', 
          fontSize: '9pt', 
          fontWeight: 'bold',
          textAlign: 'center',
          borderBottom: '1px solid #000',
          paddingBottom: '2px'
        }}>
          DÉCISION CONSEIL DES PROFESSEURS
        </h4>
        
        <div style={{ fontSize: '8pt', lineHeight: '1.4' }}>
          {decisions.map((decision) => (
            <div key={decision.value} style={{ 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '3px'
            }}>
              <span style={{ 
                fontSize: '8pt',
                fontWeight: '500',
                color: '#000'
              }}>
                {decision.label}
              </span>
              
              <div style={{ 
                display: 'flex', 
                alignItems: 'center',
                gap: '4px'
              }}>
                <span style={{ 
                  fontSize: '8pt',
                  color: '#000'
                }}>
                  ................
                </span>
                <div style={{ 
                  width: '12px',
                  height: '12px',
                  border: '1px solid #000',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '8pt',
                  fontWeight: 'bold',
                  backgroundColor: '#fff'
                }}>
                  {tableauHonneur?.decision_conseil === decision.value ? 'V' : ''}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrintDecisionConseil;
